module.exports = __webpack_public_path__ + "static/img/text-intro-btn-en.20d8325.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/wait/img/text-intro-btn-en.png
// module id = czOd
// module chunks = 1